/**
 *
 * RedirectButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'none',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('600')]: {
      justifyContent: 'center',
    },
  },
  linkText: {
    alignItems: 'center',
    textTransform: 'none',
    color: ({ color }) =>
      color ? theme.palette.text.secondary : theme.palette.text.primary,
    ...theme.typography.overline,
  },
}));

function RedirectButton({ color, label, url = '/' }) {
  const classes = useStyles({ color });
  const history = useHistory();

  const redirect = () => {
    history.push(url);
  };

  return (
    <ButtonBase disableRipple className={classes.link} onClick={redirect}>
      <Typography className={classes.linkText}>{label}</Typography>
    </ButtonBase>
  );
}

RedirectButton.propTypes = {
  color: PropTypes.bool,
  label: PropTypes.string,
  url: PropTypes.string,
};

export default RedirectButton;
